import axios from 'axios';
import { GET_BIENS, GET_SPECIFIC_BIEN, ADD_BIEN, EDIT_BIEN, DELETE_BIEN, CLEAR_BIENS, CLEAR_SPECIFIC_BIEN, BIENS_LOADING } from '../types';
import { tokenConfig } from './authActions';
import { returnErrors } from './errorActions';
import { IBien } from '../../types/interfaces';
import store from '../store';

export const getBiens = (projectId: number, association: number = 0) => (dispatch: Function, getState: Function) => {
  // dispatch(setBiensLoading());
  dispatch({
    type: BIENS_LOADING
  });
  axios
    .get('/api/biens', {...tokenConfig(getState), params: {projectId, association}})
    .then(res =>
      dispatch({
        type: GET_BIENS,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getBiensPromise = async (projectId: number, projectName: string, association: number = 0) : Promise<IBien[]> => {
  return new Promise((resolve) => {
  axios
    .get('/api/biens', {...tokenConfig(store.getState), params: {projectId, projectName, association}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err => 
      console.log("err getBiensPromise", err)
    );
  });
};

export const getBiensAll = (projectId: number) => (dispatch: Function, getState: Function) => {
  // dispatch(setBiensLoading());
  dispatch({
    type: BIENS_LOADING
  });
  axios
    .get('/api/biens/all', {...tokenConfig(getState), params: {projectId}})
    .then(res =>
      dispatch({
        type: GET_BIENS,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getPlanBiens = (projectId: number, projectName: string) => (dispatch: Function, getState: Function) => {
  // dispatch(setBiensLoading());
  dispatch({
    type: BIENS_LOADING
  });
  axios
    .get('/api/biens/biens_plan', {...tokenConfig(getState), params: {projectId, projectName}})
    .then(res =>
      dispatch({
        type: GET_BIENS,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const getBiensByN = async (n: string, projectId: number) : Promise<IBien[]> => {
  return new Promise((resolve) => {
  axios
    .get('/api/biens/byN', {...tokenConfig(store.getState), params: {n, projectId}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err =>
      console.log("err getBiensByN", err)
      // dispatch(returnErrors(err.response.data, err.response.status))
    );
  });
};

export const getBienById = (id: number) => (dispatch: Function, getState: Function) => {
  dispatch({
    type: BIENS_LOADING
  });
  axios
    .get('/api/biens/specific', {...tokenConfig(getState), params: {id}})
    .then(res =>
      dispatch({
        type: GET_SPECIFIC_BIEN,
        payload: res.data
      })
    )
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
    });
};

export const searchBiens = async (tranche: string, type: string, immeuble: string, num: string, etage: string) : Promise<IBien[]> => {
  return new Promise((resolve) => {
  axios
    .get('/api/biens/search', {...tokenConfig(store.getState), params: {tranche, type, immeuble, num, etage}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err =>
      console.log("err searchBiens", err)
      // dispatch(returnErrors(err.response.data, err.response.status))
    );
  });
};

export const getBienTypes = async (projectId: any) : Promise<any> => {
  return new Promise((resolve, reject) => {
  axios
    .get('/api/biens/types', {...tokenConfig(store.getState), params: {projectId}})
    .then(res =>
      resolve(res.data)
    )
    .catch(err => 
      reject(err)
    );
  });
};

export const addBien = (bien: IBien, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/biens', {bien}, tokenConfig(getState))
    .then(res =>{
      dispatch({
        type: ADD_BIEN,
        payload: res.data
      });
      callback(true)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const editBien = (id: number, prixMin: number, prixMinM: number, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/biens/edit', {id, prixMin, prixMinM}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: EDIT_BIEN,
        payload: res.data
      });
      callback(res.data)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const deOrBloqueBien = (bienId: number, bloque: number, deblockDate: any, bloqueFor: any, comment: string, by_user_id: number | undefined, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/biens/de_ou_bloquer', {bienId, bloque, deblockDate, bloqueFor, comment, by_user_id}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: EDIT_BIEN,
        payload: res.data
      });
      callback(res.data, null, bloque)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false, err?.response?.data?.msg)
    });
};

export const deOrSvBien = (bienId: number, sv: number, by_user_id: number | undefined, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .post('/api/biens/de_ou_sv', {bienId, sv, by_user_id}, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: EDIT_BIEN,
        payload: res.data
      });
      callback(res.data, null)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false, err?.response?.data?.msg)
    });
};

export const deleteBien = (id: number, callback: Function) => (
  dispatch: Function,
  getState: Function
) => {
  axios
    .delete(`/api/biens/${id}`, tokenConfig(getState))
    .then(res => {
      dispatch({
        type: DELETE_BIEN,
        payload: id
      })
      callback(true)
    })
    .catch(err => {
      if(err?.response)
        dispatch(returnErrors(err.response.data, err.response.status))
      else
        dispatch(returnErrors(err || "error", 469))
      callback(false)
    });
};

export const clearBiens = () => (
  dispatch: Function,
  getState: Function
) => {
  dispatch({
    type: CLEAR_BIENS
  })
};

export const clearBienCard = () => (dispatch: Function) => {
  dispatch({
    type: CLEAR_SPECIFIC_BIEN
  });
};